import FormCheckbox from './FormCheckbox';
import { CheckboxWithLabelProps } from './types';

export type { CheckboxWithLabelProps };
export default FormCheckbox;
